import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { endPoint } from '../../EndPoints/endPoint';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null, // for new file (File object)
  fileName: '',
  remarks: '',
  filePath: '',
  isNew: true, // ✅ identify new file
  fullUrl: '', // ✅ for existing file preview
});
const UpdateUnitMaster = ({ initialData, viewOnly: viewOnlyProp, onClose, onSaved } = {}) => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  let navigate = useNavigate();
  const userName = useSelector(getName);
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false]);
  const [loading, setloader] = useState(false);
  // Master Listings
  const [bedRoomList, setBedRoomList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitViewList, setunitViewList] = useState([]);
  const [contactPerson, setContactPerson] = useState([]);
  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [landlordList, setLandlordList] = useState([]);

  // Unit Listings
  const [furnishing, setFurnishing] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const [supplierCheck, setSupplierCheck] = useState('');
  const [leaseCheck, setLeaseCheck] = useState([]);
  const location = useLocation();
  const leaseData = initialData ?? location.state;
  const viewOnly = Boolean(viewOnlyProp ?? leaseData?.viewOnly);
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
  const formatDate = (date) => {
    return moment(date).format('DD-MMM-YYYY');
  };

  const [transectionData, setTransectionData] = useState({
    property: null,
    unitType: null,
    unitCategory: null,
    contactPerson: null,
    unitNo: '',
    roundoff: '',
    notes: '',
    totalvalue: '',
    mobile: '',
  });
  const [unitDetails, setUnitDetails] = useState({
    bedRooms: null,
    unitView: null,
    furnishing: null,
    saller: null,
    landlordId: null,
    utilityRoom: '',
    studyRoom: '',
    laundryRoom: '',
    maidRoom: '',
    storeRoom: '',
    plotNO: '',
    bathRoom: '',
    plotSize: '',
    parking: '',
    balcony: '',
    parkingPrice: '',
    totalArea: '',
    sqftRate: '',
    allPrice: '',
    registrationFee: '',
    completionDate: formattedDate,
  });
  const [salesDetails, setSalesDetails] = useState({
    currency: null,
    orignalPrice: '',
    orignalRateSqft: '',
    profit: '',
    profitCalculate: '',
    listingPrice: '',
    listingPriceRate: '',
    priceinothercontry: '',
    mainSalePrice: '',
    marketAnalysis: '',
    to: '',
    commPaid: '',
    commPaidCalculate: '',
    commSeller: '',
    commSellerCalculate: '',
    sellerTransferFee: '',
    sellerTransferFeeCalcu: '',
    buyerTransferFee: '',
    buyerTransferFeeCalcu: '',
    legalFee: '',
    legalFeeCalcu: '',
    miscFee: '',
    miscFeeCalcu: '',
    comment: '',
    sellerPaidDev: '',
    sellerPaidDevCalcu: '',
    amountDueDev: '',
    amountDueDevCalcu: '',
  });
  const [buyerSummery, setBuyerSummery] = useState({
    sellerTransfer: '',
    developerBalance: '',
    developerBalancePerc: '',
    BuyerCommission: '',
    BuyerCommissionPerc: '',
    DlDTransfer: '',
    DlDTransferPerc: '',
    administrationFee: '',
    administrationFeePerc: '',
    otherFee: '',
    otherFeePerc: '',
    allPrice: '',
    allPricePerc: '',
  });
  const [leaseDetails, setLeaseDetails] = useState({
    dueDate: formattedDate,
    rentPerAnum: '',
    rentByMonth: '',
    rentPerDay: '',
    securityDeposit: '',
    securityDepositPerc: '',
    tenantCommission: '',
    tenantCommissionPerc: '',
    landlordCommission: '',
    landlordCommissionPerc: '',
    maintenanceFee: '',
    rentPayable: '',
    IbanNo: '',
    secDepositPayable: '',
    commissionPayable: '',
    bankName: null,
    accountNo: '',
    fixedCharges: '',
    variableCharges: '',
    installment: '',
  });

  useEffect(() => {
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
    if (!leaseData?.ref_No) {
      toast.warning('No unit selected for update');
      if (onClose) {
        onClose();
      } else {
        navigate('/Customer/Property/Master/Unit/Listing', { replace: true });
      }
      return;
    }
    fetchDropdownData();
  }, [leaseData?.ref_No, navigate]);

  const fetchDropdownData = async () => {
    if (!leaseData?.ref_No) return;
    try {
      const params = new URLSearchParams();
      params.append('dropdownTypes', 'UMProperties,UMFloors,UMUnitViews,UMSellers,UMUnitTypes,UMUnitCategories,UMFurnishing,UMBedrooms,UMAgents');
      const res = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${params.toString()}`);
      debugger
      setFloorList(res?.data?.dropdowns?.UMFloors);
      setPropertyList(res?.data?.dropdowns?.UMProperties);
      setunitCategoryList(res?.data?.dropdowns?.UMUnitCategories);
      setunitViewList(res?.data?.dropdowns?.UMUnitViews);
      setUnitTypeList(res?.data?.dropdowns?.UMUnitTypes);
      setFurnishing(res?.data?.dropdowns?.UMFurnishing);
      setBedRoomList(res?.data?.dropdowns?.UMBedrooms);
      setContactPerson(res?.data?.dropdowns?.UMAgents);
      setLandlordList(res?.data?.dropdowns?.UMSellers);
      if (leaseData) {
        const params = new URLSearchParams();
        params.append('Action', 'GetUnitDetailsByRefNo');
        params.append('UnitRefNo', leaseData?.ref_No);
        const unitres = await apiService.getApiParamater('GET_UNIT_COMMON', `?${params.toString()}`);
        let unitData = unitres?.data?.result?.data;
        const unitView = res?.data?.dropdowns?.UMUnitViews?.find((dep) => dep.text === leaseData?.unit_View);
        const property = res?.data?.dropdowns?.UMProperties?.find((dep) => dep.value === leaseData?.property_No);
        const unitType = res?.data?.dropdowns?.UMUnitTypes?.find((dep) => dep.text === leaseData?.unit_Type);
        const unitCategory = res?.data?.dropdowns?.UMUnitCategories?.find((dep) => dep.text === leaseData?.unit_Category);
        const furnishing = res?.data?.dropdowns?.UMFurnishing?.find((dep) => dep.text === unitData?.Facilities);
        const bedrooms = res?.data?.dropdowns?.UMBedrooms?.find((dep) => dep.text === leaseData?.bedrooms);
        const floor = res?.data?.dropdowns?.UMFloors?.find((dep) => dep.text === leaseData?.floor);
        const contactPersons = res?.data?.dropdowns?.UMAgents?.find((dep) => dep.text === unitData?.Broker_Name);
        const saller = res?.data?.dropdowns?.UMSellers?.find((dep) => dep.value === unitData?.Seller_Id);

        setTransectionData({
          property: { label: property?.text, value: property },
          unitType: { label: unitType?.text, value: unitType },
          unitCategory: { label: unitCategory?.text, value: unitCategory },
          contactPerson: { label: contactPersons?.text, value: contactPersons },
          unitNo: leaseData?.unit_No || '',
          roundoff: leaseData?.roundOff_Value || '',
          notes: leaseData?.remarks || '',
          totalvalue: leaseData?.total_Value || '',
          mobile: '',
        });
        setUnitDetails({
          bedRooms: { label: bedrooms?.text, value: bedrooms },
          unitView: { label: unitView?.text, value: unitView },
          furnishing: { label: furnishing?.text, value: furnishing },
          saller: { label: saller?.text, value: saller?.value },
          landlordId: { label: saller?.value, value: saller?.text },
          floor: { label: floor?.text, value: floor },
          utilityRoom: unitData?.Street_No || '',
          studyRoom: unitData?.FinanceCompany || '',
          laundryRoom: unitData?.Street_Name || '',
          maidRoom: unitData?.StoreRooms || '',
          storeRoom: leaseData?.storeRooms || '',
          plotNO: leaseData?.plot_No || '',
          bathRoom: unitData?.Bathrooms || '',
          plotSize: leaseData?.plot_Size || '',
          parking: leaseData?.parking || '',
          balcony: unitData?.Balcony || '',
          parkingPrice: leaseData?.parking_Price || '',
          totalArea: leaseData?.total_Area || '',
          sqftRate: leaseData?.sqft_Rate || '',
          allPrice: leaseData?.all_In_Price || '',
          registrationFee: unitData?.Buyer_TransferFee || '',
          completionDate: unitData?.completion_Date,
          rent: unitData?.Rent_Per_Annum,
        });
        setSupplierCheck(unitData?.Unit_Class ?? unitData?.unit_Class ?? unitData?.UnitClass ?? '');
        setLeaseCheck(unitData?.USP ? unitData.USP.split("/") : []);

        // Images actually live in two different places depending on how they
        // got here: GET_FILE queries the generic FileUpload storage table by
        // refNo (works for anything uploaded that way), while the unit's own
        // unitImages - what UPDATE_UNIT actually writes to (folder/url/
        // isAdded, confirmed via Swagger) - only comes back from GetById.
        // Pull both and show whichever has data, so images saved either way
        // are visible.
        // Get Unit Images
        const imagesParam = new URLSearchParams();
        imagesParam.append('Action', 'GetUnitImagesByRefNo');
        imagesParam.append('UnitRefNo', leaseData.ref_No);
        const imgResp = await apiService.getApiParamater('GET_UNIT_COMMON', `?${imagesParam.toString()}`);
        const imgResult = imgResp?.data?.result?.data;
        // remarks was previously hardcoded to '' here, so the saved description
        // never showed up on edit - and since handleSave falls back to the
        // filename when remarks is blank, every save then overwrote the real
        // description with the filename instead of preserving it.
        const resolveRemarks = (item) => {
          const desc = item?.Image_Description ?? item?.image_Description ?? item?.ImageDescription ?? item?.imageDescription ?? '';
          return desc && desc !== '0' ? desc : '';
        };
        if (imgResult?.length || imgResult?.Record_Id) {
          if (imgResult?.length > 0) {
            const apiFiles = imgResult.map((item) => ({
              id: Date.now() + Math.random(),
              file: null,
              fileName: item.Image_Filename,
              remarks: resolveRemarks(item),
              filePath: item?.Folder,
              isNew: false,
              fullUrl: item.Url,
              record_Id: item?.Record_Id || 0,
            }));
            setAttachments([...apiFiles, createEmptyRow()]);
          } else {
            const apiFiles = [{
              id: Date.now() + Math.random(),
              file: null,
              fileName: imgResult.Image_Filename,
              remarks: resolveRemarks(imgResult),
              filePath: imgResult?.Folder,
              isNew: false,
              fullUrl: imgResult.Url,
              record_Id: imgResult?.Record_Id || 0,
            }];
            setAttachments([...apiFiles, createEmptyRow()]);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleBackClick = () => {
    if (onClose) {
      onClose();
      return;
    }
    window.history.back();
  };
  const handleSave = async () => {
    if (viewOnly) {
      return;
    }
    try {
      setloader(true);
      const unitFeatures = featuresList?.map((item, index) => {
        return {
          status: item?.DescType || '0',
          description: item?.Description || '0',
          value: item?.Value,
          cnt: parseFloat(item?.Cnt) || 0,
          amount: parseFloat(item?.Amount) || 0,
          isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
        };
      });
      const selectedchecks = leaseCheck.join("/");

      // Upload any newly-picked files BEFORE building the UPDATE_UNIT body,
      // not after: the Swagger schema for this endpoint's unitImages entries
      // needs the real folder/url the upload call returns, with isAdded:
      // true - the previous code sent a permanently hardcoded placeholder
      // (isAdded: false) in this same call and only fired the raw file
      // upload afterward with no way to feed its result back in, so the unit
      // record's own unitImages never reflected a newly added image at all.
      const editRefNo = leaseData?.ref_No;
      let uploadedImageResults = [];
      let imageUploadError = null;
      if (attachments) {
        try {
          uploadedImageResults = await handleUpload(editRefNo);
        } catch (uploadError) {
          console.error('Error uploading unit images', uploadError);
          imageUploadError = uploadError?.message || 'Unit saved, but the image upload failed. Please try uploading the image again.';
        }
      }
      // Pass the upload response straight through - Url is the file's real
      // fullUrl from UNIT_FILE (where the bytes actually live), not a
      // constructed path. Folder gets sent too, but the backend hardcodes
      // it to refNo regardless (confirmed in UnitManagementRepository.cs's
      // InsertUnitImages/UpdateUnitImages) - included here only because the
      // DTO has the field, not because this value is what ends up stored.
      //
      // unitImages has to carry BOTH the images that were already attached
      // (isAdded: false - they already exist, nothing to add) and the ones
      // just uploaded (isAdded: true), so the update call doesn't drop the
      // pre-existing images: e.g. 4 existing attachments + 1 newly-picked
      // file => 5 entries, not just the 1 new one.
      const existingImages = attachments
        .filter((item) => !item.isNew && item.fileName)
        .map((item) => ({
          record_Id: item?.record_Id || 0,
          image_Description: item?.remarks || item?.fileName || '0',
          image_Filename: item?.fileName || '0',
          isDefault: true,
          folder: item?.filePath || '0',
          url: item?.fullUrl || '0',
          isAdded: false,
          isUpdated: false,
          isDeleted: false,
        }));
      const newImages = (uploadedImageResults || []).map((item) => {
        const description = item?.remarks || item?.originalFileName || item?.fileName || 'Image';
        return {
          record_Id: item?.record_Id || 0,
          image_Description: description,
          image_Filename: item?.fileName || '0',
          isDefault: true,
          folder: item?.filePath || '0',
          url: item?.fullUrl || '0',
          isAdded: true,
          isUpdated: false,
          isDeleted: false,
        };
      });
      const combinedImages = [...existingImages, ...newImages];
      const unitImages = combinedImages.length
        ? combinedImages
        : [
          {
            record_Id: 0,
            image_Description: '0',
            image_Filename: '0',
            isDefault: true,
            folder: '0',
            url: '0',
            isAdded: false,
            isUpdated: false,
            isDeleted: false,
          },
        ];

      const body = {
        unitMasterMain: {
          unitMaster: {
            ref_No: leaseData?.ref_No,
            property_No: transectionData?.property?.value?.value || '0',
            property_Name: transectionData?.property?.label || '0',
            unit_No: transectionData?.unitNo || '0',
            rerA_STR_No: '0',
            street_No: unitDetails?.utilityRoom || '0',
            street_Name: unitDetails?.laundryRoom || '0',
            unit_Type: transectionData?.unitType?.label || '0',
            unit_Category: transectionData?.unitCategory?.label || '0',
            unit_Style: '0',
            unit_Model: '0',
            unit_Zone: '0',
            plot_No: unitDetails?.plotNO || '0',
            plot_Size: unitDetails?.plotSize || '0',
            block: '0',
            floor: unitDetails?.floor?.label || '0',
            unit_View: unitDetails?.unitView?.label || '0',
            completion_Date: unitDetails?.completionDate,
            unit_Class: supplierCheck || '0',
            livingRooms: '0',
            bedrooms: unitDetails?.bedRooms?.label || '0',
            storeRooms: unitDetails?.maidRoom || '0',
            parking: unitDetails?.parking || '0',
            facilities: unitDetails?.furnishing?.label || '0',
            status: '0',
            usp: selectedchecks,
            payment_Plan: '0',
            broker_Name: transectionData?.contactPerson?.label || '0',
            seller_Id: unitDetails?.landlordId?.label || '0',
            seller_Name: unitDetails?.saller?.label || '0',
            adv_Listing: true,
            adv_OpenHouse: true,
            adv_Remarks1: '0',
            adv_Remarks2: '0',
            adv_Remarks3: '0',
            remarks: transectionData?.notes || '0',
            internalRemarks: '0',
            otherSpace1: '0',
            bathrooms: unitDetails?.bathRoom || '0',
            balcony: unitDetails?.balcony || '0',
            terrace: '0',
            total_Area: parseFloat(unitDetails?.totalArea) || 0,
            measured_Area: 0,
            sqft_Rate: parseFloat(unitDetails?.sqftRate || 0),
            purchase_Value: 0,
            total_Value: parseFloat(transectionData?.totalvalue || 0),
            measured_Value: 0,
            roundOff_Value: parseFloat(transectionData?.roundoff || 0),
            parking_Price: parseFloat(unitDetails?.parkingPrice) || 0,
            all_In_Price: parseFloat(unitDetails?.allPrice || 0),
            premium: 0,
            premium_Percent: 0,
            seller_Commission: 0,
            seller_Commission_Percent: 0,
            buyer_Commission: 0,
            buyer_Commission_Percent: 0,
            seller_TransferFee: 0,
            seller_TransferFee_Percent: 0,
            buyer_TransferFee: parseFloat(unitDetails?.registrationFee || 0),
            buyer_TransferFee_Percent: 0,
            admin_Fees: 0,
            admin_Fees_Percent: 0,
            other_Fees: 0,
            other_Fees_Percent: 0,
            other_Fees_Remarks: '0',
            seller_Paid: 0,
            seller_Paid_Percent: 0,
            developer_Due: 0,
            developer_Due_Percent: 0,
            rent_Per_Annum: parseFloat(unitDetails?.rent || 0),
            short_Term_Rent: 0,
            short_Term_Period: '0',
            rent_Per_Day: 0,
            security_Deposit: 0,
            advance_Deposit: 0,
            tenant_Commission: 0,
            landlord_Commission: 0,
            maintenance_Fee: 0,
            negotiable: true,
            currency: '0',
            cmA_Range1: 0,
            cmA_Range2: 0,
            installments: 0,
            rentPayableTo: '0',
            rentBankName: '0',
            rentBankAcNo: '0',
            secDepPayableTo: '0',
            comPayableTo: '0',
            key_Status: '0',
            publishStatus: true,
            serviceCharge: '0',
            ownerOccupied: true,
            leased: supplierCheck === 'Lease' ? true : false,
            leaseAmount: 0,
            leaseExpiry: unitDetails?.expiryDate,
            mandate: '0',
            financeCompany: unitDetails?.studyRoom || '0',
            mortgaged: true,
            mortgageCompany: '0',
            propertyRegistered: true,
            portfolio: 0,
            portfolioManager: '0',
            propertyType: '0',
            factor: 0,
            common: 0,
            cp: 0,
            effeciency: '0',
            listingPriceUSD: 0,
            monthlyIncome: '0',
            annualIncome: '0',
            exp9: '0',
            exp10: '0',
            refered_By: '0',
            refered_On: unitDetails?.reffferedDate,
            createdBy: userName || '0',
            createdOn: today,
            modifiedBy: userName || '0',
            modifiedOn: today,
          },
          unitFeatures: unitFeatures,
          unitImages: unitImages,
          unitPayables: [
            {
              description: '0',
              value: true,
              landlord: true,
              tenant: true,
            },
          ],
          unitYearlyRents: [
            {
              year: 0,
              rentPerSqftRest: 0,
              rentPerSqftKitchen: 0,
              rentPerSqftTerrace: 0,
              totalRent: 0,
              scPerSqftRest: 0,
              scPerSqftKitchen: 0,
              scPerSqftTerrace: 0,
              totalServiceCharge: 0,
              chilledWaterPerSqftRest: 0,
              chilledWaterPerSqftKitchen: 0,
              chilledWaterPerSqftTerrace: 0,
              totalChilledWaterCharge: 0,
            },
          ],
          unitFixedCharges: [
            {
              description: '0',
              amount: 0,
            },
          ],
        },
      };
      const postRes = await apiService.put('UPDATE_UNIT', body);
      // The backend can respond 204 No Content on a successful update - no
      // JSON body at all, so postRes.data.statusCode is undefined and this
      // check never matched, silently skipping the whole success branch
      // below. postRes.status is the real HTTP status axios always sets,
      // body or not.
      const isSaveSuccessful = [200, 201, 204].includes(postRes?.status) || [200, 201].includes(postRes?.data?.statusCode);
      if (isSaveSuccessful) {
        // Surfaced separately from the unit-save success below, since the
        // unit record itself did save fine even if the image upload (done
        // earlier, above) failed - see imageUploadError.
        if (imageUploadError) {
          toast.warning(imageUploadError);
        }
        toast.success(postRes?.data?.message || 'Unit updated successfully.');
        setloader(false);
        if (onSaved) {
          onSaved();
        } else {
          navigate('/Customer/Property/Master/Unit/Listing');
        }
      } else {
        toast.warning(postRes?.data?.message || 'Failed to update unit. Please try again.');
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      // Previously silent: this catch never showed the user anything, so a
      // thrown/network/validation error on the save call itself (before
      // postRes even comes back) looked exactly like clicking Save did
      // nothing at all.
      toast.error(error?.response?.data?.message || error?.message || 'Failed to save unit. Please try again.');
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  // Returns the uploaded files' [{ fileName, filePath, fullUrl, ... }] so the
  // caller can build the UPDATE_UNIT body's unitImages entries with real
  // data - see handleSave, which now uploads before building that body.
  // Returns [] when there's nothing new to upload.
  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);
    if (!validFiles.length) return [];
    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    formData.append('refNo', ref_No || leaseData?.ref_No || '');
    formData.append('fileCategory', 'Images');

    const response = await axios.post(endPoint.UNIT_FILE, formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });
    // The upload call itself succeeding (HTTP 200) doesn't mean the file was
    // actually saved - the API can still return isSuccessful: false with no
    // result rows. This was never checked before, so a failed upload looked
    // identical to a successful one from here on. Same check already proven
    // in customerDocumentHelpers.js's uploadCustomerDocuments for the same
    // UNIT_FILE endpoint.
    const results = response?.data?.result || [];
    if (!response?.data?.isSuccessful && !results.length) {
      throw new Error(response?.data?.message || 'Image upload failed');
    }
    // The upload API only returns file storage metadata (fileName, filePath,
    // fullUrl, ...) - it never sees the row's own Remarks input, since that's
    // a purely frontend field never sent to it. Pair each result back with
    // the row it came from (by position - same order-preserving convention
    // already used for this same upload endpoint in
    // customerDocumentHelpers.js's uploadCustomerDocuments) so the caller can
    // use that row's remarks as the image description.
    return results.map((result, index) => ({ ...result, remarks: validFiles[index]?.remarks || '' }));
  };
  return (
    <div className="d-flex flex-column unit-modal-form" style={{ height: '85vh' }}>
      <div className="p-3 border-bottom d-flex align-items-center justify-content-between flex-shrink-0">
        <div>
          <h5 className="mb-0">{viewOnly ? t('unitMaster.viewFormTitle') : t('unitMaster.editFormTitle')}</h5>
          {viewOnly && <span className="text-muted small">{t('common.viewOnlyNotice')}</span>}
        </div>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleBackClick}></button>
      </div>
      <div className="p-3" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
        <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
          <div className="nav nav-pills overslid d-flex gap-4 unit-modal-tabs">
            <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
              {t('unitMaster.tabs.propertyDetails')}
            </div>
            <div className={`dashitems sidebar-text center ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
              {t('unitMaster.tabs.unitDetails')}
            </div>
            <div className={`dashitems sidebar-text center ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
              {t('unitMaster.tabs.unitFeatures')}
            </div>
            <div className={`dashitems sidebar-text center ${activeTab === 7 ? 'sideActive' : ''}`} onClick={() => handleTabClick(7)}>
              {t('unitMaster.tabs.images')}
            </div>
          </div>
        </div>
        {/* Lease Details */}
        {gridVisibility[0] && (
          <MasterDetails
            readOnly={viewOnly}
            tableLoading={tableLoading}
            setTransectionData={setTransectionData}
            propertyList={propertyList}
            setFeaturesList={setFeaturesList}
            transectionData={transectionData}
            unitTypeList={unitTypeList}
            contactPerson={contactPerson}
            unitCategoryList={unitCategoryList}
            setunitCategoryList={setunitCategoryList}
          />
        )}
        {gridVisibility[1] && (
          <UnitDetails
            readOnly={viewOnly}
            tableLoading={tableLoading}
            bedRoomList={bedRoomList}
            supplierCheck={supplierCheck}
            setTransectionData={setUnitDetails}
            furnishing={furnishing}
            setSupplierCheck={setSupplierCheck}
            setLeaseCheck={setLeaseCheck} leaseCheck={leaseCheck}
            floorList={floorList}
            transectionData={unitDetails} landlordList={landlordList}
            unitViewList={unitViewList}
          />
        )}
        {gridVisibility[2] && (
          <UnitFeature readOnly={viewOnly} tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />
        )}
        {gridVisibility[7] && (
          <ImagesList
            readOnly={viewOnly}
            attachments={attachments}
            deletedFiles={deletedFiles}
            setDeletedFiles={setDeletedFiles}
            setAttachments={setAttachments}
            createEmptyRow={createEmptyRow}
          />
        )}
      </div>
      <div className="p-3 border-top d-flex justify-content-start gap-3 flex-shrink-0">
        {!viewOnly &&
          (loading === true ? (
            <div className="mainbtn flex-end gap-2">
              <ClipLoader color="#ffffff" className="mt-1" size={20} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2" onClick={handleSave}>
              <FaSave color="#fff" className="center mt-1 mx-2" />
              <div className="center">{t('common.save')}</div>
            </div>
          ))}
        <div className={viewOnly ? 'mainbtn flex-end gap-2' : 'mainbtnRed flex-end gap-2'} onClick={handleBackClick}>
          <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
          <div className="center">{viewOnly ? t('common.close') : t('common.cancel')}</div>
        </div>
      </div>
    </div>
  );
};
export default UpdateUnitMaster;
